import qs from 'query-string'

import filterObject from './filterObject'

const ALLOWED_PARAM_NAMES = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'ref_id']

function getLoadboardFwdQueryParams() {
  const hashParts = window.location.hash.split('?')
  const hashQuery = hashParts.length > 1 ? hashParts[hashParts.length - 1] : ''

  if (!hashQuery) {
    return {}
  }

  const parsedQuery = qs.parse(hashQuery) || {}
  const utmQuery = filterObject(parsedQuery, propName => ALLOWED_PARAM_NAMES.includes(propName))

  return utmQuery
}

export default getLoadboardFwdQueryParams
